import React from "react";
import { AlertTriangle } from "lucide-react";

/**
 * Top-of-page banner that signals the user is in the sandbox / non-production
 * environment. Visibility is controlled by REACT_APP_ENVIRONMENT:
 *   - "production" → banner hidden
 *   - anything else (or unset) → banner shown
 */
export const SandboxBanner = () => {
  const env = (process.env.REACT_APP_ENVIRONMENT || "").toLowerCase();
  if (env === "production") return null;

  return (
    <div
      data-testid="sandbox-banner"
      role="status"
      aria-label="Sandbox environment indicator"
      className="w-full bg-amber-500 text-slate-900 border-b border-amber-600"
    >
      <div className="max-w-screen-2xl mx-auto px-4 py-1.5 flex items-center justify-center gap-2 text-xs sm:text-sm font-semibold">
        <AlertTriangle className="w-3.5 h-3.5 flex-shrink-0" />
        <span className="uppercase tracking-wider">Sandbox</span>
        <span className="hidden sm:inline font-normal opacity-80">
          · You are viewing a non-production environment. Data and integrations may be simulated.
        </span>
      </div>
    </div>
  );
};

export default SandboxBanner;
